import { IonSpinner } from '@ionic/react';
import { useHistory } from 'react-router';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { PostContentsToHTML } from '../components/PostContentsToHTML';
import { IconArrowBack } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { siteSettingsTextReplacements } from '../util/siteSettingsTextReplacements';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
export const TermsOfService: React.FC = () => {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const history = useHistory();
	return (
		<QuirkIonPage roles={['anonymous', 'user']} name="Terms of Service">
			{!siteSettings ? (
				<QuirkIonContent fullscreen={true} scroll={false}>
					<div className="center-align">
						<IonSpinner color="primary" />
					</div>
				</QuirkIonContent>
			) : (
				<>
					<Header
						title="logo"
						left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />}
					/>
					<QuirkIonContent>
						<div className={sharedStyles.contentWrapper}>
							<PostContentsToHTML>
								{siteSettings &&
									siteSettingsTextReplacements(siteSettings, siteSettings.termsOfService)}
							</PostContentsToHTML>
						</div>
					</QuirkIonContent>
				</>
			)}
		</QuirkIonPage>
	);
};
